import { Button, Icon, Layout, Menu } from "antd";
import { SelectParam } from "antd/lib/menu";
import * as React from "react";
import { Link, Redirect, Route, Switch, withRouter } from "react-router-dom";
import AuthService from "src/helpers/AuthService";
import Login from "./auth/login";
import { ProtectedRoute } from "./auth/ProtectedRoute";
import HistoryPage from "./historyPage/HistoryPage";
import PredictPage from "./PredictionPage/PredictPage";

const { Header, Content, Footer, Sider } = Layout;

export default class AppLayout extends React.Component<{}, {}> {
  constructor(props: {}) {
    super(props);

    this.state = {};

    this.handleMenuSelect = this.handleMenuSelect.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
  }

  public render() {
    // define the content that is going to be rendered
    // const contentMovie = () => <p>movie</p>;
    // const contentPerson = () => <p>people</p>;
    const noMatch = () => <p>404 Error</p>;

    const contentHeader = ({ location }: { location: any }) => {
      let path: string = location.pathname;
      path = path.replace("/", "");
      path = path.charAt(0).toUpperCase() + path.slice(1);
      return (
        <Header className="app-header">
          <span />
          <span>{path}</span>
          {new AuthService().isLoggedIn() ? (
            <Button style={{ marginRight: "24px" }} onClick={this.handleLogout}>
              Logout
            </Button>
          ) : (
            <span />
          )}
        </Header>
      );
    };

    const linkMenu = withRouter(props => {
      const { location } = props;
      return (
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={[location.pathname]}
          onSelect={this.handleMenuSelect}
        >
          <Menu.Item key="/prediction">
            <Link to="/prediction">
              <Icon type="upload" className="nav-text" />
              <span className="nav-text">Prediction</span>
            </Link>
          </Menu.Item>
          {/* <Menu.Item key="/movies">
            <Link to="/movies">
              <Icon type="video-camera" className="nav-text" />
              <span className="nav-text">Movies</span>
            </Link>
          </Menu.Item>
          <Menu.Item key="/people">
            <Link to="/people">
              <Icon type="user" className="nav-text" />
              <span className="nav-text">People</span>
            </Link>
          </Menu.Item> */}
          <Menu.Item key="/history">
            <Link to="/history">
              <Icon type="upload" className="nav-text" />
              <span className="nav-text">History</span>
            </Link>
          </Menu.Item>
        </Menu>
      );
    });

    return (
      <Layout>
        <Sider
          style={{
            height: "100vh",
            left: 0,
            overflow: "auto",
            position: "fixed"
          }}
        >
          <div className="logo">Movie Estimator</div>
          {new linkMenu(this.props)}
        </Sider>
        <Layout style={{ marginLeft: 200 }}>
          <Route render={contentHeader} />
          <Content
            style={{
              margin: "24px 16px 0",
              minHeight: "calc(100vh - 157px)",
              overflow: "initial"
            }}
          >
            <div style={{ padding: 24, background: "#fff" }}>
              <Switch>
                <Redirect exact={true} path={"/"} to={"/prediction"} />
                <ProtectedRoute
                  authenticationPath="/login"
                  path="/prediction"
                  component={PredictPage}
                />
                {/* <ProtectedRoute
                  authenticationPath="/login"
                  path="/movies"
                  render={contentMovie}
                />
                <ProtectedRoute
                  authenticationPath="/login"
                  path="/people"
                  component={contentPerson}
                /> */}
                <ProtectedRoute
                  authenticationPath="/login"
                  path="/history"
                  component={HistoryPage}
                />
                <Route path="/login" component={Login} />
                <Route component={noMatch} />
              </Switch>
            </div>
          </Content>
          {/* TODO: make the footer go to the bottom of the page */}
          <Footer>Movie Revenue ©2018 Created by LM and AG</Footer>
        </Layout>
      </Layout>
    );
  }

  private handleLogout() {
    new AuthService().logout();
    this.forceUpdate();
  }
  private handleMenuSelect(select: SelectParam) {
    const selectedNumber = Number(select.key);
    this.setState({ content: selectedNumber });
  }
}



// WEBPACK FOOTER //
// ./src/components/AppLayout.tsx